"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveClassifierPublicData = void 0;
function saveClassifierPublicData(context, params, dataChanged) {
    var _a, _b;
    const publicDataKey = 'classifier-' + ((_a = params.classifierName) !== null && _a !== void 0 ? _a : params.entityName);
    if (dataChanged || !context.publicData.exists(publicDataKey)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const storage = context.storage(params.entityName);
        const values = storage
            .list((_b = params.listRequest) !== null && _b !== void 0 ? _b : {
            filter: [{ column: 'status', op: '=', value: 'active' }],
            orderBy: params.displayOrder ? [{ column: 'displayOrder' }, { column: 'name' }] : [{ column: 'name' }],
        })
            .rows.map((row) => {
            if (params.mapValue) {
                return params.mapValue(row);
            }
            else if (params.mapValueDetailed) {
                return params.mapValueDetailed(storage.get(row.id));
            }
            else {
                return { value: row.id, label: row.columns.name };
            }
        });
        context.publicData.put(publicDataKey, {
            content: JSON.stringify(values),
            contentType: 'application/json',
        });
    }
}
exports.saveClassifierPublicData = saveClassifierPublicData;
